<template>
        <v-layout class="guidelines-layout relative-position" column>
            <v-btn  flat
                    fab
                    data-qe-id="guidelines-close-btn"
                    class="close-icon"
                    @click="closeGuidelines"
                    color="ypo_blue"
            >
                <i class="fas fa-times"></i>
            </v-btn>
            <v-layout column>
                <v-flex class="guideline-title">
                    {{imageGuidelinesConstants.GUIDELINES_TITLE}}
                </v-flex>
                <v-flex class="guideline-body">
                    <ol>
                        <li class="guideline-body__text"
                            v-for="(guideline, index) in imageGuidelinesConstants.guidelines"
                            :key="index">
                            {{guideline}}
                        </li>
                    </ol>
                </v-flex>
                <v-flex class="guideline-body__warning">
                    {{imageGuidelinesConstants.GUIDELINE_WARNING}}
                </v-flex>
            </v-layout>
            <v-layout column>
                <v-flex class="guideline-body__recommended">
                    {{imageGuidelinesConstants.RECOMMENDED_SIZE}}
                </v-flex>
                <v-flex>
                    <v-img
                            class="guidelines-image"
                            :src="require('../../assets/safe-area-desktop.png')">
                    </v-img>
                </v-flex>
            </v-layout>
        </v-layout>
</template>

<script>
    import { imageGuidelinesConstants } from "./newsFeed.constant";

    export default {
        name: 'ImageGuidelines',
        props: {
            toggleShowImageGuidelines: {
                type: Function,
                required: true,
            },
        },
        data: () => ({
            imageGuidelinesConstants,
        }),
        methods: {
            closeGuidelines() {
                if (this.toggleShowImageGuidelines) this.toggleShowImageGuidelines();
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import "../../common/styles/_responsive.scss";

    .guidelines-layout{
        border: 1px solid $ypo-gray;
        border-radius: 4px;
        padding: 20px;
        @include breakpoint(xs) {
            padding: 10px;
        }
    }

   .close-icon {
        z-index: 10;
        height: 28px;
        width: 28px;
        position: absolute;
        right: 10px;
        top: 10px;
       @include breakpoint(xs) {
           right: 3px;
           top: 3px;
       }
        margin: 0;

        i {
            font-size: 22px !important;
        }
    }

    .guideline-title{
        color: $ypo-blue;
        font-family: "Noto Sans", sans-serif;
        font-size: 18px;
        letter-spacing: 0;
        line-height: 24px;
        @include breakpoint(xs) {
            padding: 20px 15px 0 15px;
        }

    }
    .guideline-body{
        color: $ypo-blue;
        font-family: "Noto Sans", sans-serif;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 17px;
        padding-left: 20px;
        @include breakpoint(xs) {
            padding: 0 5px 0 8px;
        }

        &__text{
            font-size: 14px;
            margin-top: 15px;
        }

        &__warning{
            color: $ypo-orange;
            font-weight: bold;
            padding: 3px 5px 18px 42px;
            @include breakpoint(xs) {
                padding: 5px 5px 18px 32px;
            }
        }

        &__recommended{
            font-weight: bold;
            padding-bottom: 5px;
            @include breakpoint(xs) {
                font-size: 14px;
                line-height: 19px;
            }
        }
    }

    .guidelines-image{
        max-height: 440px;
    }

</style>
